import { Fragment } from 'react';

import UseTopTimesLscSelection from './UseTopTimesLscSelection';

import SelectOrgUnit from '@usas/ui-web/components/selectOrgUnit/SelectOrgUnit';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import { LOADING_MSG } from '@usas/ui-web/utils/Constants';

const TopTimesLscSelection = () => {
  const {
    isLoading,
    LSC_TOP_TIMES_SEARCH_ROLE_GROUP_ID,
    TOP_TIMES_LSC_SEARCH_ROUTE,
    isReadyState
  } = UseTopTimesLscSelection();

  return (
    <Fragment>
      {LSC_TOP_TIMES_SEARCH_ROLE_GROUP_ID && TOP_TIMES_LSC_SEARCH_ROUTE && isReadyState === true &&
        <SelectOrgUnit
          pageTitle={'LSC Top Times Selection'}
          navLink={TOP_TIMES_LSC_SEARCH_ROUTE}
          roleGroupId={LSC_TOP_TIMES_SEARCH_ROLE_GROUP_ID} />
      }
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default TopTimesLscSelection;